// extracted by mini-css-extract-plugin
module.exports = {"gridGroup":"gridGroup_gridGroup__1kh5i"};